import { useQuery } from "@rocicorp/zero/react"
import {
	IconEnvelopeFill18 as Envelope,
	IconInboxFill18 as Inbox,
} from "nucleo-ui-fill-18"

import { SlackIconGray } from "@productlane/ui"
import { queries } from "@productlane/zero/queries"

import { MetaInfo } from "@/components/meta-info"
import { NOTIFICATION_SETTINGS_COPY } from "@/screens/app/notifications/copy"
import { SettingsHeader } from "../settings-header"
import {
	settingsNavGroupClass,
	SettingsNavRow,
} from "../settings-pages/settings-nav-row"
import { ConnectSlackButton } from "./connect-slack-button"
import {
	isEmailNotificationsEnabled,
	isSlackNotificationsEnabled,
} from "./notification-status"

export function NotificationSettingsPage() {
	const [user] = useQuery(queries.currentUser())

	if (!user) return null

	const slackSettings = user.memberships?.personalSlackNotificationSettings

	return (
		<>
			<MetaInfo title="Notifications" />

			<SettingsHeader
				title="Notifications"
				subtitle={NOTIFICATION_SETTINGS_COPY.overviewSubtitle}
				docsArticle="c3daae2e-cb81-4c01-8020-329f825916d9"
			/>

			<div className={settingsNavGroupClass}>
				<SettingsNavRow
					icon={Inbox}
					title={NOTIFICATION_SETTINGS_COPY.navTitle}
					description={NOTIFICATION_SETTINGS_COPY.navDescription}
					link="/settings/notifications/inbox"
				/>
				<SettingsNavRow
					icon={Envelope}
					title="Email"
					description="Get an email for the events you pick."
					status={isEmailNotificationsEnabled(user)}
					link="/settings/notifications/email"
				/>
				<SettingsNavRow
					icon={SlackIconGray}
					title="Slack"
					description="Get a direct message in Slack for the events you pick."
					status={isSlackNotificationsEnabled(slackSettings)}
					link="/settings/notifications/slack"
					action={slackSettings ? undefined : <ConnectSlackButton />}
				/>
			</div>
		</>
	)
}
